import { render, staticRenderFns } from "./CustomerBankCard.vue?vue&type=template&id=3a6a8087&scoped=true"
import script from "./CustomerBankCard.vue?vue&type=script&lang=js"
export * from "./CustomerBankCard.vue?vue&type=script&lang=js"
import style0 from "./CustomerBankCard.vue?vue&type=style&index=0&id=3a6a8087&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a6a8087",
  null
  
)

export default component.exports